import { SelectPlus } from 'Components/SelectPlus';

// Clases del vehículo según la guía de valores Fasecolda (deben coincidir con las choices del modelo Vehicle en Django)
const VEHICLE_CLASS_OPTIONS = [
  { label: 'Automóvil', value: 'AUTOMOVIL' },
  { label: 'Bus / Buseta / Microbús', value: 'BUS / BUSETA / MICROBUS' },
  { label: 'Camión', value: 'CAMION' },
  { label: 'Camioneta pasajeros', value: 'CAMIONETA PASAJ.' },
  { label: 'Camioneta repar', value: 'CAMIONETA REPAR' },
  { label: 'Campero', value: 'CAMPERO' },
  { label: 'Carrotanque', value: 'CARROTANQUE' },
  { label: 'Chasis', value: 'CHASIS' },
  { label: 'Cuatrimoto', value: 'CUATRIMOTO' },
  { label: 'Furgón', value: 'FURGON' },
  { label: 'Furgoneta', value: 'FURGONETA' },
  { label: 'Isocarro', value: 'ISOCARRO' },
  { label: 'Motocarro', value: 'MOTOCARRO' },
  { label: 'Motocicleta', value: 'MOTOCICLETA' },
  { label: 'Pickup sencilla', value: 'PICKUP SENCILLA' },
  { label: 'Pickup doble cabina', value: 'PICKUP DOBLE CAB' },
  { label: 'Remolcador', value: 'REMOLCADOR' },
  { label: 'Remolque', value: 'REMOLQUE' },
  { label: 'Volqueta', value: 'VOLQUETA' },
];

export const SelectVehicleClass = ({ mode = 'single', ...selectProps }) => {
  const isSingleMode = mode === 'single';
  const placeholder = `Seleccionar clase${isSingleMode ? '' : 's'}`;

  return (
    <SelectPlus
      mode={mode}
      placeholder={placeholder}
      options={VEHICLE_CLASS_OPTIONS}
      {...selectProps}
    />
  );
};
